import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [
    // {
    //     // name: "Dr. Sasidhar Gumma",
    //     // namelink:"/dr-sasidhar-gumma",
    //     // position1: "Professor",
    //     // position2: "Dean - Academic Affairs",
    //     // phoneno:"0877 250 3671",
    //     // email: "dean_aa@iittp.ac.in",
    //     // image: "https://files.iittp.ac.in/images/demo/iit/SG.jpg"

    //     // social: [
    //     //     { platform: "facebook", link: "#" },
    //     //     { platform: "instagram", link: "#" },
    //     //     { platform: "twitter", link: "#" }
    //     // ]
    // },
    {
        name: "Prof. Sasidhar Gumma",
        namelink: "/dr-sasidhar-gumma",
        position1: "Professor",
        position2: "Dean - Academic Affairs",
        phoneno: "0877 250 3010",
        email: "dean_aa@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/SG.jpg"
    },
    {
        name: "Prof. Thamida Sunil Kumar",
        namelink: "/dr-thamida-sunil-kumar",
        position1: "Professor ",
        position2: "Advisor - Research",
        phoneno: "0877 250 3058",
        email: "aaa_research@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Thamida_sunil_kumar_2019.jpg"
    },
    {
        name: "Dr. Parthajit Mohapatra",
        namelink: "/dr-parthajit-mohapatra",
        position1: "Associate Professor",
        position2: "Advisor - Admissions and Scholarships",        
        phoneno: "0877 250 3257",
        email: " aaa_admissions@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/parthajitphoto.jpg"
    },   
    {
        name: "Dr. Narendra Singh",
        namelink: "/dr-narendra-singh",
        position1: "Associate Professor",
        position2: "Advisor - Courses",
        phoneno: "0877 250 3409",
        email: "aaa_courses@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Narendra%20Singh.jpg"
    },

    
    {
        name: "Ms. Ruchika",
        namelink: "#",
        position1: "Deputy Registrar",
        position2: "Areas of Responsibility : ",
        phoneno: "0877 250 3533",
        email: "dr_aa@iittp.ac.in / ruchika@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ruchika_DR.png"
    },
    {
        name: "Mr. M. Venkat Ramana",
        namelink: "#",
        position1: "Assistant Registrar",
        position2: "Areas of Responsibility :  ",
        phoneno: "0877 250 3530",
        email: "ar_admissions@iittp.ac.in / mvramana@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/Venkat_Ramana_AR.png"
    },
    // {
    //     name: "Mr. Harikrishna Reddy",
    //     namelink: "#",
    //     position1: "Assistant Registrar",
    //     position2: "Areas of Responsibility : Matters related to MS/PhD scholars, Fee, Stipend, Scholarships, Refunds, Academic Events.",
    //     phoneno: "0877 250 3530",
    //     email: "ar_research@iittp.ac.in",
    //     image: "https://files.iittp.ac.in/images/demo/iit/Staff/HariKrishnaReddy.jpg"
    // },

    // {
    //     name: "Mr. Madhu N",
    //     namelink: "#",
    //     position1: "Assistant Registrar",
    //     position2: "Areas of Responsibility : Admissions, Academic Courses, Grades, ERP, Guest Faculty, RTI, BAP & Senate. ",
    //     phoneno: "0877 250 3508",
    //     email: "ar_aa@iittp.ac.in",
    //     image: "https://files.iittp.ac.in/images/demo/iit/Staff/madhun.png"
    // },

    {
        name: "Mrs. Billu Silpa",
        namelink: "#",
        position1: "Section Officer",
        position2: "Areas of Responsibility :   ",
        phoneno: "0877 250 3531",
        email: "bsilpa@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/billusilpa.png"
    },

    {
        name: "Mr. K Prasad Rao",
        namelink: "#",
        position1: "Junior Superintendent ",
        position2: "Areas of Responsibility : Courses, Grades, ERP, Guest Faculty, BAP & Senate.",
        phoneno: "0877 250 3530",
        email: "academics@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/PRASAD RAO K.jpg"
    },

    // {
    //     name: "Mr. Srinivasulu K V",
    //     namelink: "#",
    //     position1: "Junior Superintendent ",
    //     position2: "Areas of Responsibility:",
    //     phoneno: "0877 250 XXXX",
    //     email: "academics@iittp.ac.in",
    //     image: "https://files.iittp.ac.in/images/demo/iit/Staff/KVS.jpg"
    // },


   // {
   //     name: "Mr. Mohammad Ishaq Alikhan",
   //     namelink: "#",
   //     position1: "Junior Superintendent ",
   //     position2: "Areas of Responsibility : Admissions, Statistics and Reports",
   //     phoneno: "0877 250 3532",
   //     email: "admissions@iittp.ac.in",
   //     image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ishaq_2.jpg",
    //},


    {
        name: "Mr. Manicharan Chintakrindi",
        namelink: "#",
        position1: "Junior Superintendent",
        position2: "Areas of Responsibility :  ",
        phoneno: "0877 250 3532",
        email: "manicharan@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/manicharan.jpg",
    },

     {
        name: "Mrs. Gunturu Haritha",
        namelink: "#",
        position1: "Senior Assistant ",
        position2: "Areas of Responsibility :",
        phoneno: "0877 250 3530",
        email: "academics@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/haritha.jpg",
    },

     {
        name: "Mr. V Dinesh Kumar",
        namelink: "#",
        position1: "Junior Assistant ",
        position2: "Areas of Responsibility :",
        phoneno: "0877 250 3532",
        email: "vdinesh@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/dinesh.jpg",
    },
   
    {
        name: "Ms. Basila Ali",
        namelink: "#",
        position1: "Junior Assistant ",
        position2: "Areas of Responsibility :",
        phoneno: "0877 250 3531",
        email: "academics@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/Basila_Ali_JA.png",
    },

    {
        name: "Mr. Ramaprasad Yarra",
        namelink: "#",
        position1: "Junior Assistant ",
        position2: "Areas of Responsibility :",
        phoneno: " ",
        email: "ramaprasad@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ramaprasad_Yarra_JA.png",
    },

    // {
    //     name: "Mr. A Manikantanaik",
    //     namelink: "#",
    //     position1: "Junior Assistant ",
    //     position2: "Areas of Responsibility :",
    //     phoneno: "0877 250 3532",
    //     email: "manu_012@iittp.ac.in",
    //     image: "https://files.iittp.ac.in/images/demo/iit/Staff/default.png",
    // },

    {
        name: "Mr. Vaddi Venkata Naresh",
        namelink: "#",
        position1: "Junior Assistant ",
        position2: "Areas of Responsibility :",
        phoneno: " ",
        email: "naresh2756@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/default.png",
    },

    {
        name: "Mr. Adeem Yoosuf",
        namelink: "#",
        position1: "Junior Assistant ",
        position2: "Areas of Responsibility :",
        phoneno: " ",
        email: "adeemyou@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/Adeem_Yoosuf_JA.png",
    },

    {
        name: "Ms. Nivetha Shri S",
        namelink: "#",
        position1: "Junior Assistant ",
        position2: "Areas of Responsibility :",
        phoneno: " ",
        email: "nivethashri@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/default_female.png",
    },

   




    
]

function Main() {
    return (
        <>
            <Header/>
            <Breadcrumb title="Home" subtitle="Academic Team"/>
            <section className="team-area fix p-relative pt-120 pb-80">
                {/*   */}
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Our Team
                                </h5>
                                <h2>ACADEMIC TEAM</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {teachers.map((teacher, index) => (
                           <div key={index} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="#">
                                                <img src={teacher.image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.name}</Link>
                                        </h4>
                                        <div className="text-dark">
                                        <p className='fw-bold' >{teacher.position1}</p>
                                            <p className="text-dark fw-bold">{teacher.position2}</p>
                                            <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{teacher.phoneno}</p>
                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.email} target="_blank" className="btn btn-primary">{teacher.email}</Link></p> */}
                                            <p className="text-dark"><i className="fal fa-envelope  me-2"></i>{teacher.email}</p>
                                        </div>
                                        <div className="team-social">
                                            {/* <ul>
                                                {teacher.social.map((platform, index) => (
                                                    <li key={index}>
                                                        <Link to={platform.link}>
                                                            {platform.platform === 'facebook' && <i className="fab fa-facebook-f" />}
                                                            {platform.platform === 'instagram' && <i className="fab fa-instagram" />}
                                                            {platform.platform === 'twitter' && <i className="fab fa-twitter" />}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Main